<div>
  <mat-card-header class="container p-b-16">
    <header class="site-header  py-1 border-bottom">
      <nav class="d-flex flex-column flex-md-row justify-content-between">


        <a class="py-2" href="https://andica.com/images/logo_andica.gif" aria-label="Product">
          <img class="float-md-start mb-0 d-block mx-auto radius-0" alt="Andica Limited" src="https://andica.com/images/logo_andica.gif" />
        </a>

      </nav>
    </header>
  </mat-card-header>

  <mat-card-content class="container p-x-36">
    <mat-card-header class="header-bg-dark justify-content-center" style="padding: 20px 20px !important; border-radius: 6px;">
      <div class="">
        <div class="p-3 p-md-3 mb-3 text-white rounded">
          <mat-card-title><h3 class=" text-white">{{headerText}}</h3></mat-card-title>
        </div>
      </div>
    </mat-card-header>
    <div class="col-12">
      <div class="row p-t-20 bS mobile">
        <div class="col-md-12 order-md-1 mt-3 card_space">
          <div class="card bg-light card_space">
            <div class="card-body card_space row g-5 bg-white">
              <div class="col-md-7 bg-white">
                <div class="card ">
                  <div class="card-body" [formGroup]="PasswordForm">
                    <div class="mb-3">
                      <div>
                        <mat-label class="m-b-8 f-s-14">
                          Password <span class="text-danger">*</span>
                        </mat-label>
                        <mat-form-field appearance="outline" class="m-y-8 w-100" color="primary">
                          <input matInput [type]="inputType" #passwordInput placeholder="Enter Password" formControlName="Password" (input)="OnPasswordChange(passwordInput.value);" appTrimSpace maxlength="25" />
                          @if(PasswordForm.get('Password')?.touched && PasswordForm.get('Password')?.hasError('required')){
                          <mat-error>Password  is required</mat-error>
                          }
                          @else if(PasswordForm.get('Password')?.touched && PasswordForm.get('Password')?.hasError('minlength')){
                          <mat-error>Password must be at least 8 characters</mat-error>
                          } @else if(PasswordForm.get('Password')?.touched && PasswordForm.get('Password')?.hasError('pattern')){
                          <mat-error>Enter valid Password</mat-error>
                          }
                          <mat-icon class="custom-form eye-icon" matSuffix (click)="toggleInputType('Password')">
                            {{ inputType === 'password' ? 'visibility' : 'visibility_off' }}
                          </mat-icon>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="mb-3">

                      <mat-label class="m-b-8 f-s-14">
                        Confirm Password <span class="text-danger">*</span>
                      </mat-label>
                      <mat-form-field appearance="outline" class="m-y-8 w-100" color="primary">
                        <input matInput [type]="inputTypeCP" #confirmPasswordInput placeholder="Enter Confirm Password" formControlName="ConfirmPassword" (change)="ConfirmPasswordChange()" appTrimSpace maxlength="25" appInputRestriction/>
                        @if(PasswordForm.get('ConfirmPassword')?.touched && PasswordForm.get('ConfirmPassword')?.hasError('required')){
                        <mat-error>Confirm Password  is required</mat-error>
                        }
                        @else if(PasswordForm.get('ConfirmPassword')?.touched && PasswordForm.get('ConfirmPassword')?.hasError('match')){
                        <mat-error>Password and Confirm Password must match</mat-error>
                        }
                        <mat-icon class="custom-form eye-icon" matSuffix (click)="toggleInputType('Confirm Password')">
                          {{ inputTypeCP === 'password' ? 'visibility' : 'visibility_off' }}
                        </mat-icon>
                      </mat-form-field>
                    </div>
                    <div class="text-right mb-2">
                      <div>
                        <!--*ngIf="CreatePassword"-->
                        <button mat-flat-button class="px-3 btn-charity" [disabled]="_disableCreate" (click)="CreatePassword()">
                          <mat-icon matSuffix>
                            <i-tabler name="device-floppy" class="icon-20 d-flex m-t-0"></i-tabler>
                          </mat-icon>
                          {{btnText}}
                        </button>
                        <!--<button type="submit" class="btn btn-primary login-btn text-capitalize m-2" *ngIf="!CreatePassword">Reset Password  </button>-->
                      </div>
                      <!--<button type="submit" class="btn btn-sm btn-primary">Set Password</button>-->
                    </div>
                  </div>
                </div>

              </div>
              <div class="col-md-5 m-t-10 bg-white">
                <mat-card class="card bg-notecard border-0 shadow-none">
                  <mat-card-header>
                    <mat-card-title>
                      <h5 class="head-blu f-s-16 mb-3 f-w-600">
                        Password must contain:
                      </h5>
                    </mat-card-title>
                  </mat-card-header>
                  <mat-card-content class="mt-0">
                    <div class="">
                      <div class="card-body">

                        <ul class="text-black font-code pt-3 pl-4 ml-3 mb-0 f-s-14">
                          <li [style.color]="mincolor" class="m-b-4 m-t-10">8 to  25 characters</li>
                          <li [style.color]="uccolor" class="m-b-4">At least 1 uppercase character (A-Z)</li>
                          <li [style.color]="lccolor" class="m-b-4">At least 1 lowercase character (a-z)</li>
                          <li [style.color]="numcolor" class="m-b-4">At least 1 number (0-9) </li>
                          <li [style.color]="speccolor" class="m-b-4">At least 1 special character </li>
                        </ul>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>

          </div>


        </div>

      </div>
    </div>
  </mat-card-content>
  <footer style="position: fixed; width: 100%; bottom: 0;">
    <mat-card class="p-10 f-s-12 footer boxShadow">
      <div class="row p-10 text-black-25 text-center">
        <div class="col-12 col-md-6 col-xxl-6">
          <div class="float-start text-left fw-bold text-dark">
            Copyright © <a href="https://andica.com/" target="_blank" style="color: #ff6600; font-weight: bold; text-decoration: none !important"> 2004-{{nextyear}} Andica Limited.</a> All rights reserved.
          </div>
        </div>
        <div class="col-12 col-md-6 col-xxl-6">
          <div class="footer-left text-right text-md-end">
            <a href="https://www.andica.com/legal-software-licence-agreement.html" target="_blank" class="f-w-500" style="text-decoration: none; color: #346b88;">Licence Agreement</a> <span class="m-x-5 " style="font-size:18px !important">&middot;</span>
            <a href="https://www.andica.com/legal.html" target="_blank" class="f-w-500" style="text-decoration: none; color: #346b88;">Legal Terms</a>
          </div>
        </div>
      </div>
    </mat-card>
  </footer>

</div>
@if (_disableCreate)
{
<div class="spinner-overlay">
  <mat-spinner class="spinner-cust"></mat-spinner>
</div>
}
<ng-template #ValidationModel>
  <mat-dialog-content class="mb-0">
    <div>
      <mat-card-title>
        <h5 class="f-s-16 f-w-600 mb-0 head-blu">Link Expired!</h5>
      </mat-card-title>
    </div>
    <div>
      <div class="col-12 p-x-0">
        <p class="f-s-16">{{LinkValidationMessage}}</p>
      </div>
      <div class="col-12 d-flex justify-content-end p-x-0">
        <button mat-button class="primary-btn f-s-14" (click)="OK()">
          OK
        </button>
      </div>
    </div>
  </mat-dialog-content>
</ng-template>
